module.exports = __webpack_public_path__ + "img/197-melilla.6afccb22.svg";